import { gsap } from 'gsap/dist/gsap';

/**************************************************************
-> Launch search lightbox when search button is clicked
**************************************************************/
export function searchLightboxes() {

  const buttons = Array.from(document.querySelectorAll('.search-button'))

  if (buttons) {

    buttons.forEach(button => {
      const lightbox = document.querySelector('.search-lightbox')
      const close = lightbox.querySelector('[data-lightbox-close]')
      const searchInput = document.querySelector('.search-input')
      
      button.addEventListener('click', () => {
        document.body.style.overflow = 'hidden'
        gsap.to(lightbox, { opacity: 1, pointerEvents: 'all'})
        searchInput.focus()
      })
      
      close.addEventListener('click', () => {
        document.body.style.overflow = 'initial'
        gsap.to(lightbox, { opacity: 0, pointerEvents: 'none'})
      })

    });

  }

}


// WEBPACK FOOTER //
// ./scripts/components/search.js